export default __webpack_public_path__ + "static/jmb_oilsink-da9615e9bf28f29b7ff69c16e7117028.png";